import { takeEvery } from 'redux-saga/effects'

import { InternalActions, LocksActions } from '../actions'
import { lockId } from './lockId'
import { setLock } from './setLock'

export function* locksSaga() {
  yield takeEvery(InternalActions.setLock, setLock)
  yield takeEvery(LocksActions.lockId, lockId)
}
